import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { RepositoryService } from "../../shared/services/repository.service";
import { RiskAudit } from "../../_interfaces/riskAudit.model";
import { RiskUser } from './../../_interfaces/RiskUser.model';

@Component({
  selector: 'app-risk-audit-list',
  templateUrl: './risk-audit-list.component.html',
  styleUrls: ['./risk-audit-list.component.css']
})
export class RiskAuditListComponent implements OnInit {

  @Input() public headerText: string;
  @Input() public riskAuditEntries: RiskAudit[];
  @Output() messageToEmit = new EventEmitter<string>();
  public costBased: boolean;

  public user: RiskUser;

  constructor(private repository: RepositoryService,
    private router: Router) { }

  ngOnInit() {
    this.user = this.repository.GetMyUser();
    this.repository.SetupPeople(); // Check if Risk Users are loaded - if not load them from Api
  }

  getRiskAuditDetails(riskAuditId: number) {
    let riskAuditDetailUrl: string = `/audit-entry/${riskAuditId}`;
    this.router.navigate([riskAuditDetailUrl]);
  }

}
